<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-row style="background-color: #f3f4f4">
      <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
        <img
          style="width: 16px; height: 16px; margin-right: 12px"
          src="../../../assets/img/user-list.png"
        />
        申请开票
      </el-col>
      <el-col :xs="24" :md="18" style="text-align: right">
        <el-button
          type="primary"
          v-no-more-click
          v-if="role == 'COMPANY'"
          @click="fnYwcgjfw"
          :loading="loadingbut"
          >业务成果交付物</el-button
        >
        <el-button
          type="primary"
          v-no-more-click
          v-if="
            $hasPermission('plat:platinvoicingtasklist:submit') &&
            dataForm.status == 0
          "
          @click="dataFormSubmitHandle('1')"
          :loading="loadingbut"
          >提交</el-button
        >
        <el-button
          type="primary"
          v-no-more-click
          v-if="
            $hasPermission('plat:platinvoicingtasklist:save') &&
            dataForm.status == 0
          "
          style="background-color: skyblue"
          :loading="loadingbut"
          @click="dataFormSubmitHandle('0')"
          >保存</el-button
        >
        <el-button
          type="primary"
          v-if="
            $hasPermission('plat:platinvoicingtasklist:checked') &&
            dataForm.status == 1
          "
          @click="dataFormStatusHandle('1', dataForm.id)"
          :loading="loadingbut"
          >审核通过</el-button
        >
        <el-button
          type="primary"
          v-if="
            $hasPermission('plat:platinvoicingtasklist:checked') &&
            dataForm.status == 1
          "
          style="background-color: skyblue"
          :loading="loadingbut"
          @click="dataFormStatusHandle('0', dataForm.id)"
          >驳回</el-button
        >
        <el-button
          type="primary"
          v-if="(dataForm.status == 2 && role == 'OPERATE') || (dataForm.status == 2 && this.$store.state.user.isSourceOfTax == 1)"
          style="background-color: skyblue"
          :loading="loadingbut"
          @click="dataFormImageHandle()"
          >保存凭证</el-button
        >

        <el-button @click="getInfo()">刷新</el-button>

        <el-button @click="handleReturn()">返回列表</el-button>
      </el-col>
    </el-row>
    <div>
      <el-form
        :model="dataForm"
        :rules="
          (dataForm.status == 2 || dataForm.status == 3) && role == 'OPERATE' ? dataRule1 : dataRule
        "
        ref="dataForm"
        @keyup.enter.native="dataFormSubmitHandle()"
        :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'"
      >
        <div style="padding: 10px 33px; border-bottom: 4px solid #f3f4f4">
          <div
            style="
              font-size: 14px;
              font-weight: bold;
              padding: 33px 0px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <span>开票主体</span>
            <div v-if="dataForm.status > 0">
              <el-button type="primary" @click="handleRwDetail()"
                >任务详情</el-button
              >
              <el-button type="primary" @click="handleHtDetail()"
                >合同详情</el-button
              >
              <el-button type="primary" @click="handleJsDetail()"
                >结算详情</el-button
              >
            </div>
          </div>
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="120px" label="开票主体名称：">
                <el-input
                  style="width: 95%"
                  v-model="dataForm.bodyName"
                  placeholder="开票主体名称"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="150px" label="统一社会信用编码">
                <el-input
                  style="width: 95%"
                  v-model="dataForm.mainPartBodyTaxCode"
                  placeholder="统一社会信用编码"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="170px" label="企业规模：">
                <el-input
                  style="width: 95%"
                  v-model="dataForm.scale"
                  placeholder="企业规模"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div style="padding: 10px 33px; border-bottom: 4px solid #f3f4f4">
          <div
            style="
              font-size: 14px;
              font-weight: bold;
              padding: 33px 0px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <span>开票信息</span>
            <div v-if="dataForm.status > 0">
              <el-dropdown @command="handleCommand" v-if="role == 'OPERATE'">
                <el-button type="primary">
                  下载<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                    >下载企业营业执照</el-dropdown-item
                  >
                  <el-dropdown-item command="b">下载合同</el-dropdown-item>
                  <el-dropdown-item command="c"
                    >下载商户上线及任务发布信息表</el-dropdown-item
                  >
                  <el-dropdown-item command="d"
                    >下载业务确认及服务成果验收单</el-dropdown-item
                  >
                  <el-dropdown-item command="e"
                    >下载业务成果交付物</el-dropdown-item
                  >
                  <el-dropdown-item command="f"
                    >下载发票申请单</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-button type="primary" @click="downFpsqd()" v-else>下载发票申请单</el-button> -->
            </div>
          </div>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label-width="140px"
                label="购买方企业名称："
                prop="buyerName"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.buyerName"
                  placeholder="购买方企业名称"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="购买方纳税人识别号："
                prop="buyerTaxCode"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.buyerTaxCode"
                  placeholder="购买方纳税人识别号"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="开户行名称："
                prop="buyerBankName"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.buyerBankName"
                  placeholder="开户行名称"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label-width="140px"
                label="银行账号："
                prop="buyerBankAccount"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.buyerBankAccount"
                  placeholder="银行账号"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="联系地址："
                prop="buyerAddress"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.buyerAddress"
                  placeholder="联系地址"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="联系电话："
                prop="buyerPhone"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.buyerPhone"
                  placeholder="联系电话"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div style="padding: 10px 33px; border-bottom: 4px solid #f3f4f4">
          <div style="font-size: 14px; font-weight: bold; padding: 33px 0px">
            发票接收地址
          </div>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label-width="140px"
                label="收票人姓名："
                prop="receiverName"
              >
                <el-input
                  style="width: 95%"
                  v-if="dataForm.status > 0"
                  :disabled="true"
                  v-model="dataForm.receiverName"
                  placeholder="收票人姓名"
                ></el-input>
                <el-input
                  style="width: 95%"
                  v-else
                  v-model="dataForm.receiverName"
                  placeholder="收票人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="收票人地址："
                prop="receiverAddress"
              >
                <el-input
                  style="width: 95%"
                  v-if="dataForm.status > 0"
                  :disabled="true"
                  v-model="dataForm.receiverAddress"
                  placeholder="收票人地址"
                ></el-input>
                <el-input
                  style="width: 95%"
                  v-else
                  v-model="dataForm.receiverAddress"
                  placeholder="收票人地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="收票人电话："
                prop="receiverPhone"
              >
                <el-input
                  style="width: 95%"
                  v-if="dataForm.status > 0"
                  :disabled="true"
                  v-model="dataForm.receiverPhone"
                  placeholder="收票人电话"
                ></el-input>
                <el-input
                  style="width: 95%"
                  v-else
                  v-model="dataForm.receiverPhone"
                  placeholder="收票人电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label-width="140px"
                label="电子邮件地址："
                prop="email"
              >
                <el-input
                  style="width: 95%"
                  v-if="dataForm.status > 0"
                  :disabled="true"
                  v-model="dataForm.email"
                  placeholder="电子邮件地址"
                ></el-input>
                <el-input
                  style="width: 95%"
                  v-else
                  v-model="dataForm.email"
                  placeholder="电子邮件地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div style="padding: 10px 33px; border-bottom: 4px solid #f3f4f4">
          <div style="font-size: 14px; font-weight: bold; padding: 33px 0px">
            发票信息
          </div>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label-width="140px"
                label="发票类型："
                prop="ticketType"
              >
                <el-select
                  style="width: 95%"
                  v-model="dataForm.ticketType"
                  :disabled="dataForm.status > 0 ? true : false"
                  placeholder="发票类型"
                  clearable
                >
                  <el-option label="增值税专票" value="增值税专票"></el-option>
                  <el-option label="增值税普票" value="增值税普票"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="开票项目："
                prop="taskTypeName"
              >
              <el-input
                  style="width: 95%"
                  readonly
                  v-model="dataForm.taskTypeName"
                  :disabled="dataForm.status > 0 ? true : true"
                  placeholder="开票项目"
                ></el-input>
                <!-- <el-select
                  style="width: 95%"
                  @change="getvalue"
                  v-model="dataForm.invoiceItem"
                  :disabled="dataForm.status > 0 ? true : false"
                  filterable
                  placeholder="开票项目"
                >
                  <el-option
                    v-for="(item, index) in prolist"
                    :key="item.id"
                    :label="item.ticketProject"
                    :value="index"
                  >
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="170px" label="开票金额含税（元）：">
                <el-input
                  style="width: 95%"
                  readonly
                  v-model="dataForm.money"
                  :disabled="dataForm.status > 0 ? true : true"
                  placeholder="开票金额含税"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="140px" label="税率：" prop="taxRate">
                <el-input
                  style="width: 95%"
                  v-model="dataForm.taxRate"
                  placeholder="税率"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="170px" label="数量：" prop="quantity">
                <el-input
                  style="width: 95%"
                  v-model="dataForm.quantity"
                  :disabled="statusNum"
                  placeholder="数量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="170px" label="单位（张）：">
                <el-input
                  style="width: 95%"
                  readonly
                  v-model="dataForm.unit"
                  :disabled="dataForm.status > 0 ? true : false"
                  placeholder="单位"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="dataForm.isPtxTicket == 1">
            <!-- <el-col :span="8">
							<el-form-item label-width="140px" label="发票代码：" prop="invoiceCode">
								<el-input style="width: 95%;" v-model="dataForm.invoiceCode" placeholder="发票代码" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label-width="170px" label="发票号码：" prop="invoiceNum">
								<el-input style="width: 95%;" v-model="dataForm.invoiceNum" :disabled="dataForm.status > 0?true:false" placeholder="发票号码"></el-input>
							</el-form-item>
						</el-col> -->
            <el-col :span="8">
              <el-form-item label-width="170px" label="开票时间：">
                <el-input
                  style="width: 95%"
                  v-model="dataForm.finishDate"
                  :disabled="dataForm.status > 0 ? true : false"
                  placeholder="开票时间"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="dataForm.isPtxTicket == 1">
            <el-col :span="8">
              <el-form-item
                label-width="140px"
                label="发票金额："
                prop="invoiceMoney"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.invoiceMoney"
                  placeholder="发票金额"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="170px"
                label="发票税额："
                prop="taxMoney"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.taxMoney"
                  :disabled="dataForm.status > 0 ? true : false"
                  placeholder="发票税额"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label-width="170px" label="价税合计：">
                <el-input
                  style="width: 95%"
                  v-model="dataForm.money"
                  :disabled="true"
                  placeholder="价税合计"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="dataForm.status >= 1 && role == 'OPERATE'">
            <!-- <el-col :span="8">
              <el-form-item
                label-width="140px"
                label="发票代码："
                prop="invoiceCode"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.invoiceCode"
                  :disabled="dataForm.status != 2 ? true : false"
                  placeholder="发票代码"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item
                v-if="dataFormStatus"
                label-width="140px"
                label="发票号码："
                prop="invoiceNum"
              >
                <el-input
                  style="width: 95%"
                  v-model="dataForm.invoiceNum"
                  :disabled="statusNum"
                  placeholder="多个发票号码用逗号隔开填写"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="dataFormStatus">
              <el-form-item
                label-width="170px"
                label="开票日期："
                prop="finishDate"
              >
                <el-date-picker
                  style="width: 95%"
                  v-model="dataForm.finishDate"
                  placeholder="开票日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :disabled="statusNum"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 付款凭证 -->
        <div style="padding: 10px 33px">
          <el-row>
            <el-col :span="12">
                <!-- <el-form-item prop="paymentVoucher" label="付款凭证" v-if="(role != 'COMPANY' && dataForm.status == 1) || (role != 'COMPANY' && dataForm.status == 2) || (role != 'COMPANY' && dataForm.status == 3)"> -->
                <el-form-item prop="paymentVoucher" label="付款凭证">
                  <el-upload
                    class="avatar-uploader"
                    :action="url"
                    :show-file-list="false"
                    :before-upload="beforeUploadHandle"
                    :on-success="successHandle"
                    :on-error="backerror"
                    :disabled="dataForm.status != 0 ? true : false"
                  >
                    <div style="position: relative">
                      <img v-if="dataForm.paymentVoucher && dataForm.paymentVoucher.indexOf('pdf') === -1" :src="dataForm.paymentVoucher" class="avatar"/>
                      <img v-else-if="dataForm.paymentVoucher && dataForm.paymentVoucher.indexOf('pdf') !== -1" :src="require('../../../assets/img/pdf.png')" class="avatar"/>
                      <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height: 100px !important"></i>
                      <span v-if="dataForm.paymentVoucher && dataForm.status <= 0" class="uploadSty" @click.stop="delPayment()" >
                        <i class="el-icon-delete"></i>
                      </span>
                    </div>
                    <div slot="tip" class="el-upload__tip" style="width: 100%;margin-top:-20px;">
                      支持上传PDF、图片等
                    </div>
                  </el-upload>
                  <el-button type="primary" v-if="dataForm.paymentVoucher" @click.stop="yulan" style="margin-top: 5px">预览</el-button>
                </el-form-item>
            </el-col>
            <!-- 发票附件 -->
            <el-col :span="12" v-if="role != 'COMPANY' || dataForm.status == 3">
              <el-form-item prop="invoicePath" label="发票附件"
                v-if="
                  (dataForm.status == 2 && invoicePath.length < 5) ||
                  (dataForm.status == 2 && dataForm.invoicePath != null) ||
                  (dataForm.status == 3 && dataForm.invoicePath != null)
                "
              >
                <div v-if="dataForm.invoicePath != null" v-for="(item, index) in invoicePath" style="display: inline-block; margin: 0px 10px 20px">
                  <div style="position: relative">
                    <img v-if="item && item.indexOf('pdf') === -1" :src="item" class="avatar"/>
                    <img v-else :src="require('../../../assets/img/pdf.png')" class="avatar"/>
                    <span class="uploadSty" v-if="dataForm.status != 3" @click="deleteinfo(index)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </div>
                  <el-button type="primary" v-if="item" @click="yulantwo(item)" style="margin-top: 5px">预览</el-button>
                </div>
                <div style="display: inline-block; margin: 0px 10px 20px"
                  v-if="
                    (dataForm.status == 2 && invoicePath.length < 5) ||
                    (dataForm.status == 2 && dataForm.invoicePath == null)
                  "
                >
                  <el-upload
                    class="avatar-uploader"
                    :action="url"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUploadHandle"
                    :on-success="successinvoiceHandle"
                    :on-error="backerror"
                  >
                    <i class="el-icon-plus avatar-uploader-icon" style="line-height: 100px !important"></i>
                    <div slot="tip" class="el-upload__tip" style="margin-top:-3px;">
                      支持上传PDF、图片等
                    </div>
                  </el-upload>
                </div></el-form-item
              >
            </el-col>


          </el-row>
          <el-row>
            <!-- 业务成果交付物 -->
            <el-col :span="12">
                <el-form-item prop="finishProofPath" label="业务成果">
                  <el-upload
                    class="avatar-uploader"
                    :action="url"
                    :show-file-list="false"
                    :before-upload="beforeUploadHandle"
                    :on-success="successinvoiceHandle1"
                    :on-error="backerror"
                    :disabled="(role == 'COMPANY' && dataForm.status == 0) || (role != 'COMPANY') ? false : true"
                  >
                    <div style="position: relative">
                      <img v-if="dataForm.finishProofPath && dataForm.finishProofPath.indexOf('pdf') === -1" :src="dataForm.finishProofPath" class="avatar"/>
                      <img v-else-if="dataForm.finishProofPath && dataForm.finishProofPath.indexOf('pdf') !== -1" :src="require('../../../assets/img/pdf.png')" class="avatar"/>
                      <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height: 100px !important"></i>
                      <span v-if="dataForm.finishProofPath && dataForm.status <= 0" class="uploadSty" @click.stop="delPayment1()" >
                        <i class="el-icon-delete"></i>
                      </span>
                    </div>
                    <div slot="tip" class="el-upload__tip" style="width: 100%;margin-top:-20px;">
                      支持上传PDF、图片等
                    </div>
                  </el-upload>
                    <el-button type="primary" v-if="dataForm.finishProofPath" @click.stop="yulanThree(dataForm.finishProofPath)" style="margin-top: 5px">预览</el-button>
                </el-form-item>
            </el-col>
          </el-row>
          <!-- 业务成果交付物 -->
          <!-- <el-row>
            <el-col :span="12" v-if="role == 'COMPANY' && dataForm.status == 0">
              <el-form-item prop="finishProofPath" label="业务成果交付物"
                v-if="
                  (dataForm.status == 2 && finishProofPath.length <= 1) ||
                  (dataForm.status == 3 && finishProofPath.length <= 1) ||
                  (dataForm.status == 2 && dataForm.finishProofPath != null) ||
                  (dataForm.status == 3 && dataForm.finishProofPath != null)
                "
              >
                <div v-if="dataForm.finishProofPath.length > 0" v-for="(item, index) in finishProofPath" style="display: inline-block; margin: 0px 10px 20px">
                  <div style="position: relative">
                    <img v-if="item && item.indexOf('pdf') === -1" :src="item" class="avatar"/>
                    <img v-else :src="require('../../../assets/img/pdf.png')" class="avatar"/>
                    <span class="uploadSty1" @click="fnDownUrl(item)">
                      <i class="el-icon-download"></i>
                    </span>
                    <span class="uploadSty" v-if="role != 'COMPANY'" @click="deleteinfo1(index)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </div>
                  <el-button type="primary" v-if="item" @click="yulantwo(item)" style="margin-top: 5px">预览</el-button>
                </div>
                <div style="display: inline-block; margin: 0px 10px 20px"
                  v-if="
                  (dataForm.status == 2 || dataForm.status == 3) && finishProofPath.length < 1
                  "
                >
                  <el-upload
                    class="avatar-uploader"
                    :action="url"
                    :show-file-list="false"
                    list-type="picture-card"
                    :before-upload="beforeUploadHandle"
                    :on-success="successinvoiceHandle1"
                    :on-error="backerror"
                  >
                    <i class="el-icon-plus avatar-uploader-icon" style="line-height: 100px !important"></i>
                    <div slot="tip" class="el-upload__tip">
                      支持上传PDF、图片等
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-row> -->
          
          
        </div>
      </el-form>

      <el-row
        style="border-top: 5px solid #f3f4f4"
        v-if="dataForm.platTicketProcessDTOList.length > 0"
      >
        <div
          style="
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 40px;
            padding: 30px 30px 0px;
          "
        >
          申请状态
          <!-- <span style="margin-left: 40px;">申请编号</span>
				<span style="margin-left: 40px;">{{dataForm.id}}</span>
				<span style="margin-left: 40px;" v-if="dataForm.ticketStatus == 0">未开票</span>
				<span style="margin-left: 40px;" v-else-if="dataForm.ticketStatus == 1">待审核</span>
				<span style="margin-left: 40px;" v-else>已开票</span> -->
        </div>
        <div
          style="
            line-height: 25px;
            padding: 10px 0;
            font-size: 12px;
            padding: 0px 30px;
          "
        >
          <p
            style="
              margin: 0;
              line-height: 50px;
              border-bottom: 1px solid #f3f4f4;
            "
          >
            申请编号<span style="margin-left: 40px">{{
              dataForm.ticketApplyCode
            }}</span>
          </p>
          <p
            style="
              margin: 0;
              line-height: 50px;
              border-bottom: 1px solid #f3f4f4;
            "
            v-for="(value, key) in dataForm.platTicketProcessDTOList"
          >
            <!-- <span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span> -->
            {{ value.createDate }}
            <span style="margin-left: 30px">{{ value.username }}</span>
            <span style="margin-left: 30px" v-if="value.status == 0">
              草稿</span
            >
            <span style="margin-left: 30px" v-if="value.status == 1"
              >待审核</span
            >
            <span style="margin-left: 30px" v-if="value.status == 2"
              >已完成</span
            >
            <span style="margin-left: 30px" v-if="value.status == 3"
              >已开票</span
            >
            <span style="margin-left: 30px">{{ value.content }}</span>
          </p>
        </div>
      </el-row>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-card>
</template>

<script>
import debounce from "lodash/debounce";
import { addDynamicRoute } from "@/router";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      role: Cookies.get("admin_role"),
      dialogVisible: false,
      dialogImageUrl: "",
      visible: false,
      invoicePath: [],
      finishProofPath:[],
      dataForm: {
        id: "",
        taskId: "",
        mainPartBodyName: "",
        mainPartBodyTaxCode: "",
        scale: "",
        status: "",
        buyerName: "",
        buyerTaxCode: "",
        buyerBankName: "",
        buyerBankAccount: "",
        buyerAddress: "",
        buyerPhone: "",
        receiverName: "",
        receiverAddress: "",
        receiverPhone: "",
        ticketType: "增值税普票",
        invoiceItem: "",
        money: "",
        taxRate: "6%",
        quantity: "",
        unit: "",
        paymentVoucher: "",
        platTicketProcessDTOList: [],
        ticketProCode: "",
        ticketProName: "",
        invoiceCode: "",
        taxMoney: "",
        invoiceNum: "",
        invoicePath: "",
        finishProofPath: "",
        invoiceMoney: "",
        taxMoney: "",
        finishDate: "",
        dealApprovalId: "",
        dealApprovalIds: "",
        isPtxTicket: 0,
        email: "",
      },
      total: 0,
      url: `${
        window.SITE_CONFIG["apiURL"]
      }/oss/file/upload2?access_token=${Cookies.get("access_token")}`,
      num: 0,
      type: "",
      prolist: [],
      loadingbut: false,
      formUrl: "",
      count:0,
    };
  },
  computed: {
    dataRule() {
      var checkNum = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback();
        } else {
          callback(new Error("请输入数字值,并且最多两位小数"));
        }
      };
      var checkNumthree = (rule, value, callback) => {
        if (!/^\+?[1-9][0-9]*$/.test(value)) {
          callback(new Error("请输入数字值"));
        }
        callback();
      };
      var checkfloat = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback();
        } else {
          callback(new Error("请输入数字值,并且最多两位小数"));
        }
      };
      var checkphone = (rule, value, callback) => {
        if (/^1\d{10}$/.test(value)) {
          callback();
        } else if (/^0\d{2,3}-?\d{7,8}$/.test(value)) {
          callback();
        } else {
          callback(new Error("请输入手机号"));
        }
      };
      var checkEmail = (rule, value, callback) => {
        if ( /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)) {
          callback();
        }  else {
          callback(new Error("请输入邮箱号"));
        }
      };
      var checkcard = (rule, value, callback) => {
        if (
          /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(
            value
          )
        ) {
          callback();
        } else {
          callback(new Error("请输入身份证号"));
        }
      };
      var checkbank = (rule, value, callback) => {
        if (/^([A-Za-z0-9]{16}|[A-Za-z0-9]{17}|[A-Za-z0-9]{19})$/.test(value)) {
          callback();
        } else {
          callback(new Error("请输入卡号"));
        }
      };

      var checkNumtwo = (rule, value, callback) => {
        if (/^[A-Za-z0-9]{7,20}$/.test(value)) {
          callback();
        } else {
          callback(new Error("社会信用代码格式错误"));
        }
      };

      var validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          return callback(
            new Error(
              this.$t("validate.format", { attr: this.$t("user.email") })
            )
          );
        }
        callback();
      };

      return {
        // 开票信息校验
        buyerName: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        buyerTaxCode: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        buyerBankName: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        buyerBankAccount: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        buyerAddress: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        buyerPhone: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],

        receiverName: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        receiverAddress: [
          {
            required: false,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        receiverPhone: [
          {
            required: false,
            message: "输入正确的电话号码",
            // validator: checkphone,
            trigger: "blur",
          },
        ],
        ticketType: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        invoiceItem: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入数字值,并且最多两位小数",
            validator: checkNum,
            trigger: "blur",
          },
        ],
        taxRate: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        quantity: [
          {
            required: true,
            message: "请输入整数",
            validator: checkNumthree,
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        firstPhone: [
          {
            required: true,
            message: "输入正确的电话号码",
            validator: checkphone,
            trigger: "blur",
          },
        ],
        paymentVoucher: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        finishProofPath: [
          {
            required: this.dataForm.isFirstApplication == 1 ? true : false ,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: false,
            message: "输入正确的邮箱号码",
            // validator: checkEmail,
            trigger: "blur",
          },
        ],
      };
    },
    dataRule1() {
      var checkNew1 = (rule, value, callback) => {
        if (/^[0-9]+$/.test(value)) {
          callback();
        } else {
          callback(new Error("数量必需是正整数"));
        }
      };
      var checkNew2 = (rule, value, callback) => {
        if (value) {
          var arr1 = [];
          var arr = this.transArry(value);
          arr.map((item, inxex) => {
            arr1.push(/^[0-9]{8}$|^[0-9]{20}$/.test(item));
          });
          if (arr1.includes(false)) {
            callback(new Error("发票号码必须为8位或20位数字"));
          } else {
            callback();
          }
        } else {
          callback(new Error("发票号码不能为空"));
        }
      };

      return {
        invoicePath: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        finishProofPath: [
          {
            required: this.dataForm.isFirstApplication == 1 ? true : false ,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        paymentVoucher: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        // invoiceCode: [
        //   {
        //     required: true,
        //     message: '发票代码必须为10位或12位',
        //     validator: checkNew1,
        //     trigger: "blur",
        //   },
        // ],
        invoiceNum: [
          {
            required: true,
            message: "发票号码必须为8位或20位数字",
            trigger: "blur",
            validator: checkNew2,
          },
        ],
        quantity: [
          {
            required: true,
            message: "数量必须为正整数",
            trigger: "blur",
            validator: checkNew1,
          },
        ],
        finishDate: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
      };
    },
    statusNum() {
      if (this.dataForm.status == 2 && this.role == "OPERATE") {
        return false;
      } else {
        return true;
      }
    },
    dataFormStatus() {
      if (this.dataForm.status != 2 && this.dataForm.status != 3) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    this.url = `${
      window.SITE_CONFIG["apiURL"]
    }/oss/file/upload2?access_token=${Cookies.get("access_token")}`;
    this.num = 0;
    this.fileList = [];
    this.dataForm.dealApprovalIds = this.$route.params.id || [];
    // console.log(localStorage.getItem('qykpRwId'))
    // console.log(this.$route.params.id)
    // this.dataForm.dealApprovalId = localStorage.getItem('qykpRwId') ? localStorage.getItem('qykpRwId') : this.$route.params.id ? this.$route.params.id : '';
    this.formUrl =
      this.$route.params.url ||
      "/sys/plat/platticketrecord/batchApplyPageData";
      // "/sys/plat/platticketrecord/apply-page-data?dealApprovalId=";
    this.init();
    this.$http
      .get(`/sys/plat/ticketPro/list`)
      .then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg);
        }
        this.prolist = res.data;
        console.log(this.prolist);
      })
      .catch(() => {});
  },
  methods: {
    // 返回上级
    handleReturn() {
      console.log(this.$route.params);
      if (this.$route.params && this.$route.params.isThreeRoute) {
        const routeParams = {
          routeName: "plat-platticketrecordqy",
          title: `企业开票记录`,
          path: "plat-platticketrecordqy",
        };
        // 动态路由
        addDynamicRoute(routeParams, this.$router);
      } else {
        this.$router.back(-1);
      }
    },
    // 任务详情
    handleRwDetail() {
      this.$http.get("/sys/user/info").then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg);
        }
        // 路由参数
        const routeParams = {
          routeName: "plat-plattask__任务详情",
          title: `任务详情`,
          path: "plat/platttask-info",
          params: {
            id: this.dataForm.taskId,
            parentId: this.dataForm.dealApprovalIds,
          },
        };
        // 动态路由
        addDynamicRoute(routeParams, this.$router);
      });
    },
    // 合同详情
    handleHtDetail() {
      console.log(this.dataForm)
      // const routeParams = {
      //   routeName: `plat-platcontract__合同详情`,
      //   title: `合同详情`,
      //   path: "plat/platcontract-info",
      //   params: {
      //     id: this.dataForm.contractId,
      //     parentId: this.dataForm.dealApprovalId,
      //   },
      // };
      // 动态路由
      // addDynamicRoute(routeParams, this.$router);
      // if(this.dataForm.bodyId == '1453241566079012865'){
        const routeParams = {
            routeName: `${this.$route.name}__合同详情`,
            title: `合同详情`,
            path: 'plat/platcontract-info',
            params: {
                id: this.dataForm.contractId,
                parentId: this.dataForm.dealApprovalIds,
            }
        }
        // 动态路由
        addDynamicRoute(routeParams, this.$router)
      
      // }else{
      //   // 路由参数
      //   const routeParams = {
      //       routeName: `${this.$route.name}__合同信息`,
      //       title: `合同信息`,
      //       path: 'user/contractDetail',
      //       params: {
      //           isContractList:true,
      //           id: this.dataForm.userId,
      //           parentId: this.dataForm.dealApprovalId,

      //       }
      //   }
        // 动态路由
        // addDynamicRoute(routeParams, this.$router)
      // }
      
    },
    // 结算详情
    handleJsDetail() {
      const routeParams = {
        routeName: `plat-batch-settlement-list__收款方信息`,
        title: `收款方信息`,
        path: "plat/batch-settlement-list/content/payee-info",
        params: {
          id: this.dataForm.dealApprovalIds,
          status: 6,
          parentId: this.dataForm.dealApprovalIds,
        },
      };
      // 动态路由
      addDynamicRoute(routeParams, this.$router);
    },
    // 下载营业执照
    handleCommand(command) {
      if (command == "a") {
        //营业执照
        window.open(this.dataForm.licensePath);
      } else if (command == "b") {
        //合同
        window.open(this.dataForm.contractFilePath);
      } else if (command == "c") {
        //商户上线及任务发布信息表
        // window.open(
        //   `${
        //     window.SITE_CONFIG["apiURL"]
        //   }/sys/plat/deal/approval/downloadBusinessTask?id=${
        //     this.dataForm.taskId
        //   }&approvalId=${
        //     this.dataForm.dealApprovalId
        //   }&access_token=${Cookies.get("access_token")}`
        // );
        if(this.dataForm.attachment){
          window.open(this.dataForm.attachment);
        }else{
          this.$message.error('商户上线及任务信息发布表为空!')
        }
      } else if (command == "d") {
        //业务确认及服务成果验收单
        // window.open(
        //   `${
        //     window.SITE_CONFIG["apiURL"]
        //   }/sys/plat/deal/approval/downloadTaskResult?id=${
        //     this.dataForm.dealApprovalId
        //   }&access_token=${Cookies.get("access_token")}`
        // );
        if(this.dataForm.finishProofPath2){
          // let arr = this.dataForm.finishProofPath2.split(",")
          // arr.map((item) => {
          //   this.downloadURL(item)
          // })
          window.open(this.dataForm.finishProofPath2);
        }else{
          this.$message.error('业务确认及服务成果验收单为空!')
        }
      } else if (command == "e") {
        //业务成果交付物
        // this.$http
        //   .get(
        //     `${
        //       window.SITE_CONFIG["apiURL"]
        //     }/sys/plat/deal/approval/downloadBusinessDeliverables?id=${
        //       this.dataForm.dealApprovalId
        //     }&access_token=${Cookies.get("access_token")}`
        //   )
        //   .then((res) => {
        //     // if(res){
        //     //   this.$message.error('暂无业务成果交付物可下载!')
        //     // }else{
        //     window.open(
        //       `${
        //         window.SITE_CONFIG["apiURL"]
        //       }/sys/plat/deal/approval/downloadBusinessDeliverables?id=${
        //         this.dataForm.dealApprovalId
        //       }&access_token=${Cookies.get("access_token")}`
        //     );
        //     // }
        //   });
        // window.open();
        if(this.dataForm.finishProofPath){
          window.open(this.dataForm.finishProofPath)
        }else{
          this.$message.error('暂无业务成果交付物可下载!')
        }
      } else if (command == "f") {
        //发票申请单
        window.open(
          `${
            window.SITE_CONFIG["apiURL"]
          }/sys/plat/platticketrecord/downloadInvoiceInfo?recordId=${
            this.dataForm.id
          }&access_token=${Cookies.get("access_token")}`
        );
      }
    },
    downloadURL(url){
      var hiddenIFrameID = 'hiddenDownloader' + this.count++;
      var iframe = document.createElement('iframe');
      iframe.id = hiddenIFrameID;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      iframe.src = url;
    },
    fnYwcgjfw() {
      window.open(
        `${
          window.SITE_CONFIG["apiURL"]
        }/sys/plat/deal/approval/downloadBusinessDeliverables?id=${
          this.dataForm.dealApprovalIds[0]
        }&access_token=${Cookies.get("access_token")}`
      );
    },
    downFpsqd() {
      window.open(
        `${
          window.SITE_CONFIG["apiURL"]
        }/sys/plat/platticketrecord/downloadInvoiceInfo?recordId=${
          this.dataForm.id
        }&access_token=${Cookies.get("access_token")}`
      );
    },
    // 匹配中英文逗号将逗号分割为数组
    transArry(str) {
      var temp = str.split(/[\n\s+,，]/g);
      for (var i = 0; i < temp.length; i++) {
        if (temp[i] == "") {
          // 删除数组中空值
          temp.splice(i, 1);
          i--;
        }
      }
      return temp;
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.dealApprovalIds && this.dataForm.dealApprovalIds.length > 0) {
          this.getInfo();
        }
      });
    },

    backerror(e) {
      this.$message.error("文件上传失败，请重试");
    },
    getvalue(e) {
      this.dataForm.ticketProCode = this.prolist[e].ticketCode;
      this.dataForm.invoiceItem = this.prolist[e].ticketProject;
      this.dataForm.ticketProName = this.prolist[e].serverName;
    },
    // 获取信息
    getInfo() {
      this.$http
        .post(this.formUrl,this.dataForm.dealApprovalIds)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message({
              message: res.msg,
              type: "error",
              duration: 500,
              onClose: () => {
                this.$router.back(-1);
              },
            });
          }
          // if (!res.data.buyerBankName) {
          //   this.$message({
          //     showClose: true,
          //     type: "warning",
          //     duration: 5000,
          //     message: "开票信息为空，请先到“开票信息”菜单维护信息!",
          //   });
          // }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
          this.dataForm.buyerTaxCode = this.dataForm.buyerTaxCode ? this.dataForm.buyerTaxCode : '';
          if (this.dataForm.ticketType == null) {
            this.dataForm.ticketType = "增值税专票";
          }
          this.invoicePath = [];
          this.invoicePath = this.dataForm.invoicePath ? this.dataForm.invoicePath.split(",") : [];
          this.finishProofPath = [];
          this.finishProofPath = this.dataForm.finishProofPath ? this.dataForm.finishProofPath.split(",") : [];

        })
        .catch(() => {});
    },
    beforeUploadHandle(file) {
      if (
        file.type != "application/pdf" &&
        file.type !== "image/jpg" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/gif"
      ) {
        this.$message.error(
          this.$t("upload.tip", { format: "jpg、png、gif、pdf" })
        );
        return false;
      }
      this.num++;
    },
    // 上传成功
    successHandle(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      if (res.code == 0) {
        this.type = res.data.fileType;
        this.dataForm.paymentVoucher = res.data.url;
        this.$refs["dataForm"].validateField('paymentVoucher');
      } else {
        this.$message.error("上传失败，请重试");
      }

      this.num--;
    },
    successinvoiceHandle(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      if (res.code == 0) {
        this.invoicePath.push(res.data.url);
        this.dataForm.invoicePath = this.invoicePath.join(",");
      } else {
        this.$message.error("上传失败，请重试");
      }

      this.num--;
    },
    // 业务 成果交付物
    successinvoiceHandle1(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      if (res.code == 0) {
        this.finishProofPath = [];
        this.finishProofPath.push(res.data.url);
        this.dataForm.finishProofPath = this.finishProofPath.join(",");
        this.$refs["dataForm"].validateField('finishProofPath');
        if(this.dataForm.status > 0){
            this.$http.post('/sys/plat/platticketrecord/uploadFinishProofPath',{
            id:this.dataForm.id,
            finishProofPath:this.dataForm.finishProofPath
          }).then((res) => {
            console.log(res)
          })
        }
        
      } else {
        this.$message.error("上传失败，请重试");
      }

      this.num--;
    },
    deleteinfo(index) {
      if (this.dataForm.ticketType != "增值税专票") {
        return false;
      }
      let that = this;
      this.$confirm("确认删除附件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.invoicePath.splice(index, 1);
          that.dataForm.invoicePath = that.invoicePath.join(",");
        })
        .catch(() => {});
    },
    // 业务成果交付物删除
    deleteinfo1(index) {
      // if (this.dataForm.ticketType != "增值税专票") {
      //   return false;
      // }
      let that = this;
      this.$confirm("确认删除附件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.finishProofPath.splice(index, 1);
          that.dataForm.finishProofPath = that.finishProofPath.join(",");
        })
        .catch(() => {});
        
    },
    fnDownUrl(item) {
      window.open(item)
    },
    delPayment() {
      this.dataForm.paymentVoucher = "";
    },
    delPayment1() {
      this.dataForm.finishProofPath = "";
    },
    yulan() {
      if (this.dataForm.paymentVoucher.indexOf("pdf") === -1) {
        this.dialogImageUrl = this.dataForm.paymentVoucher;
        this.dialogVisible = true;
      } else {
        window.open(this.dataForm.paymentVoucher, this.dataForm.paymentVoucher);
      }
    },
    yulantwo(e) {
      if (e.indexOf("pdf") === -1) {
        this.dialogImageUrl = e;
        this.dialogVisible = true;
      } else {
        window.open(e, e);
      }
    },
    yulanThree(url){
      if (url.indexOf("pdf") === -1) {
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      } else {
        window.open(url, url);
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function (inStatus) {
        this.dataForm.inStatus = inStatus;
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.loadingbut = true;
          this.$http
            .post("/sys/plat/platticketrecord/batchApply", this.dataForm)
            .then(({ data: res }) => {
              this.loadingbut = false;
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.getInfo();
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 保存凭证
    dataFormImageHandle() {
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loadingbut = true;
        this.$http
          .post("/sys/plat/platticketrecord/uploadSpecialInvoice", {
            id: this.dataForm.id,
            invoicePaths: this.dataForm.invoicePath,
            invoiceNum: this.dataForm.invoiceNum,
            finishDate: this.dataForm.finishDate,
            quantity: this.dataForm.quantity,
            paymentVoucher: this.dataForm.paymentVoucher,
            finishProofPath: this.dataForm.finishProofPath
            // invoiceCode: this.dataForm.invoiceCode,
          })
          .then(({ data: res }) => {
            this.loadingbut = false;
            if (res.code !== 0) {
              return this.$message.error(res.msg);
            }
            this.$message({
              message: this.$t("prompt.success"),
              type: "success",
              duration: 500,
              onClose: () => {
                this.getInfo();
              },
            });
          })
          .catch(() => {});
      });
    },
    dataFormStatusHandle: debounce(function (inStatus, id) {
      console.log(inStatus);
      this.$refs.dataForm.validate((valid) => {
        if (valid || inStatus == 0) {
          let _this = this;
          this.$prompt("请输入审核理由", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }).then(({ value }) => {
            let pass = inStatus == 1 ? "pass" : "return";
            this.loadingbut = true;
            this.$http
              .post(
                "/sys/plat/platticketrecord/audit",
                {
                  id: id,
                  result: pass,
                  reason: value,
                  invoicePaths: this.dataForm.invoicePath,
                  invoiceNum: this.dataForm.invoiceNum,
                  finishDate: this.dataForm.finishDate,
                  quantity: this.dataForm.quantity,
                  paymentVoucher: this.dataForm.paymentVoucher,
                },
                {
                  headers: {
                    "content-type": "application/json;charset=utf-8",
                  },
                }
              )
              .then(({ data: res }) => {
                this.loadingbut = false;
                if (res.code !== 0) {
                  return this.$message.error(res.msg);
                }
                this.$message({
                  message: this.$t("prompt.success"),
                  type: "success",
                  duration: 500,
                  onClose: () => {
                    this.getInfo();
                  },
                });
              })
              .catch(() => {});
          });
        } else {
          this.$message({
            showClose: true,
            type: "warning",
            message: "请输入必填项！",
          });
        }
      });
    }),
  },
};
</script>
<style lang="scss" scoped>
.el-form-item__content {
  line-height: 1 !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader-pic-del {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 18px;
  height: 18px;
}
.uploadSty{
  position: absolute;
  right: 0;
  bottom: 0;
  span{
    padding: 0 8px;
    background: red;
    color: #fff;
    border-radius: 7px;display: inline-block;
    cursor: pointer;
    font-size: 16px;
    &.span1{
    background: #188eee;
    }
  }
}
.uploadSty1{
  position: absolute;
  right: 30px;
  bottom: 0;
  padding: 0 5px;
  background: #188eee;
  border-radius: 7px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
}
</style>